import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private key = '826e985fd038d5ea9fe2e8b72fdc7f1d';

  decrypt(encryptedBase64: string): any {
  try {
    // base64 decode (iv + base64(cipher))
    const decoded = CryptoJS.enc.Base64.parse(encryptedBase64);

    const iv = CryptoJS.lib.WordArray.create(decoded.words.slice(0, 4), 16);

    // remaining part is UTF-8 base64 string
    const encryptedBase64Text = CryptoJS.enc.Utf8.stringify(
      CryptoJS.lib.WordArray.create(
        decoded.words.slice(4),
        decoded.sigBytes - 16
      )
    );

    const decrypted = CryptoJS.AES.decrypt(
      encryptedBase64Text,
      CryptoJS.enc.Utf8.parse(this.key),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    const text = decrypted.toString(CryptoJS.enc.Utf8);
    if (!text) throw new Error('Empty decrypted text');

    return JSON.parse(text);

  } catch (e) {
    console.error('❌ Decryption failed', e);
    return null;
  }
}

encrypt(data: any): string | null {
  try {
    const text = JSON.stringify(data);

    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(
      text,
      CryptoJS.enc.Utf8.parse(this.key),
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    // IMPORTANT: base64 string
    const cipherBase64 = encrypted.toString();

    // iv (raw bytes) + cipherBase64 (utf8 bytes)
    const combined = CryptoJS.lib.WordArray.create()
      .concat(iv)
      .concat(CryptoJS.enc.Utf8.parse(cipherBase64));

    return CryptoJS.enc.Base64.stringify(combined);

  } catch (e) {
    console.error('❌ Encryption failed', e);
    return null;
  }
}

}
